import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = {
  key: 0,
  class: "row",
  id: "schedule"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-12 col-lg-6 col-xxl-5" }
const _hoisted_6 = { class: "card" }
const _hoisted_7 = { class: "card-body justify-content-center align-items-middle d-flex flex-column text-center overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_week_schedule = _resolveComponent("week-schedule")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isUserActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_week_schedule, {
              scheduleId: "gtr-system",
              title: "Sistema de Liderazgo GTR Evolution",
              titleIcon: "fas fa-broadcast-tower",
              scheduleType: "gtrSystem"
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "card-header text-nowrap" }, [
                _createElementVNode("i", { class: "fas fa-broadcast-tower me-2" }),
                _createTextVNode("Sistema de Liderazgo GTR Academy")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "fs-1 mb-2" }, [
                  _createElementVNode("i", { class: "fas fa-lock fa-lg mx-2" })
                ], -1)),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "small d-flex flex-column overflow-hidden mb-3" }, [
                  _createElementVNode("span", { class: "small" }, [
                    _createTextVNode("Necesitas estar suscrito al "),
                    _createElementVNode("strong", null, "Sistema GTR"),
                    _createTextVNode(" para poder acceder a las clases de liderazgo de esta sección.")
                  ])
                ], -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_router_link, {
                    to: "/subscriptions",
                    class: "btn btn-primary"
                  }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode(" Ver Suscripciones ", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]))
  ]))
}